<template>
  <v-layout>
    <v-flex>
      <v-card>
        <v-card-title primary-title>
          <div>
            <div class=" title">
              Domicilio {{ domicilio.esPrincipal ? ' Principal' : ' ' }}
              {{ domicilio.esPrincipal ? '' : domicilio.orden }}
            </div>
            <span class=" caption">
              {{ domicilio.calle }} {{ domicilio.numero }} {{ domicilio.piso }}
              {{ domicilio.departamento }} , {{ domicilio.localidad }} (CP
              {{ domicilio.codigoPostal }})
              {{ domicilio.provincia }}
            </span>
          </div>
          <v-spacer></v-spacer>
          <v-tooltip bottom v-if="permitirEliminar">
            <template v-slot:activator="{ on }">
              <v-btn
                text
                icon
                bottom
                left
                color="grey"
                v-on="on"
                @click="eliminar"
              >
                <v-icon small>delete</v-icon>
              </v-btn>
            </template>
            <span>Eliminar Domicilio</span>
          </v-tooltip>
        </v-card-title>
        <v-divider light></v-divider>
        <v-card-actions>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                fab
                small
                :color="esPrincipal ? 'orange lighten-1' : 'orange lighten-4'"
                dark
                v-on="on"
                @click="marcarPredeterminado()"
              >
                <v-icon>place</v-icon></v-btn
              >
            </template>
            <span>Marcar como Predeterminado</span>
          </v-tooltip>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                fab
                small
                color="red lighten-2"
                dark
                v-on="on"
                @click="editar()"
              >
                <v-icon>edit</v-icon></v-btn
              >
            </template>
            <span>Editar Domicilio</span>
          </v-tooltip>
        </v-card-actions>
      </v-card>
    </v-flex>

    <v-dialog v-model="editModeOn" width="800" persistent>
      <v-card :dark="$store.state.UiCustomUserSettings.temaOscuro">
        <v-card-title class="headline" primary-title
          >Edición de Domicilio
          {{ esPrincipal ? ' Predeterminado' : '' }}</v-card-title
        >

        <v-container fluid grid-list-lg>
          <v-layout wrap>
            <v-flex lg4 sm6 xs12>
              <v-autocomplete
                v-model="domicilioEditor.provinciaSeleccionada"
                :items="provincias"
                return-object
                item-text="nombre"
                item-value="id"
                label="Provincia"
                placeholder="Seleccione una provincia"
                :menu-props="{ minWidth: '400' }"
              ></v-autocomplete>
            </v-flex>

            <v-flex lg4 sm6 xs12>
              <v-text-field
                v-model="domicilioEditor.localidad"
                label="Localidad"
                v-validate="'required'"
                data-vv-name="localidad"
                @input="changeLocalidad()"
                v-on:keyup="localidadesKeyUp"
                append-outer-icon="search"
                :append-icon="localidadValida ? 'done' : ''"
                @click:append-outer="buscarLocalidad()"
              ></v-text-field>
            </v-flex>

            <v-flex lg4 sm6 xs12>
              <v-text-field
                v-model="domicilioEditor.codigoPostal"
                label="C.P."
                v-validate="'required'"
                data-vv-name="código postal"
              ></v-text-field>
            </v-flex>

            <v-flex lg6 sm6 xs12>
              <v-text-field
                v-model="domicilioEditor.calle"
                label="Calle"
                v-validate="'required'"
                data-vv-name="calle"
                @input="changeCalle()"
                v-on:keyup="calleKeyUp"
                append-outer-icon="search"
                :append-icon="calleValida ? 'done' : ''"
                @click:append-outer="buscarCalle()"
              ></v-text-field>
            </v-flex>

            <v-flex lg2 sm6 xs12>
              <v-text-field
                v-model="domicilioEditor.numero"
                label="Número"
                v-validate="'required'"
                data-vv-name="número de puerta"
              ></v-text-field>
            </v-flex>

            <v-flex lg2 sm6 xs12>
              <v-text-field
                v-model="domicilioEditor.piso"
                label="Piso"
              ></v-text-field>
            </v-flex>

            <v-flex lg2 sm6 xs12>
              <v-text-field
                v-model="domicilioEditor.departamento"
                label="Dpto."
              ></v-text-field>
            </v-flex>

            <v-flex lg4 sm6 xs12 v-show="!user.esComer">
              <v-text-field
                v-model="domicilioEditor.entreCalle1"
                label="Entre Calle 1"
                append-outer-icon="search"
                :append-icon="domicilioEditor.entreCalle1Id ? 'done' : ''"
                @click:append-outer="buscarEntreCalle1()"
                v-on:keyup="entreCalle1KeyUp"
              ></v-text-field>
            </v-flex>

            <v-flex lg4 sm6 xs12 v-show="!user.esComer">
              <v-text-field
                v-model="domicilioEditor.entreCalle2"
                label="Entre Calle 2"
                append-outer-icon="search"
                :append-icon="domicilioEditor.entreCalle2Id ? 'done' : ''"
                @click:append-outer="buscarEntreCalle2()"
                v-on:keyup="entreCalle2KeyUp"
              ></v-text-field>
            </v-flex>

            <v-flex lg4 sm6 xs12>
              <v-text-field
                v-model="domicilioEditor.barrio"
                label="Barrio"
              ></v-text-field>
            </v-flex>

            <v-flex lg4 sm6 xs12>
              <v-text-field
                v-model="domicilioEditor.partido"
                label="Partido"
                v-validate="'required'"
                data-vv-name="partido"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-container>
        <v-divider></v-divider>

        <v-card-actions>
          <v-btn color="accent" text @click="editModeOn = false">
            Cancelar
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="confirmarModificacion()">
            Ok
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Lista de Localidades -->
    <app-lista-busqueda
      label="Búsqueda de Localidades por Provincia"
      :visible.sync="listaLocalidadesVisible"
      v-on:update:visivility="listaLocalidadesVisible = $event"
      :headers="headersBusquedaLocalidades"
      searchApi="Postal/listarlocalidades"
      :searchFor="
        'nombre=' +
          domicilioEditor.localidad +
          '&provinciaId=' +
          domicilioEditor.provinciaSeleccionada.id
      "
      :setSelectedItem="setLocalidadBusqueda"
    ></app-lista-busqueda>

    <!-- Lista de Calles -->
    <app-lista-busqueda
      label="Búsqueda de Calles por Localidad"
      :visible.sync="listaCallesVisible"
      v-on:update:visivility="listaCallesVisible = $event"
      :headers="headersBusquedaCalle"
      searchApi="Postal/listarcalles"
      :searchFor="
        'calle=' +
          domicilioEditor.calle +
          '&localidadId=' +
          domicilioEditor.localidadId
      "
      :setSelectedItem="setCalleBusqueda"
    ></app-lista-busqueda>

    <!-- Lista de Entre Calles 1 -->
    <app-lista-busqueda
      label="Búsqueda de Calles por Localidad"
      :visible.sync="listaEntreCalles1Visible"
      v-on:update:visivility="listaEntreCalles1Visible = $event"
      :headers="headersBusquedaCalle"
      searchApi="Postal/listarcalles"
      :searchFor="
        'calle=' +
          domicilioEditor.entreCalle1 +
          '&localidadId=' +
          domicilioEditor.localidadId
      "
      :setSelectedItem="setEntreCalle1Busqueda"
    ></app-lista-busqueda>

    <!-- Lista de Entre Calles 2 -->
    <app-lista-busqueda
      label="Búsqueda de Calles por Localidad"
      :visible.sync="listaEntreCalles2Visible"
      v-on:update:visivility="listaEntreCalles2Visible = $event"
      :headers="headersBusquedaCalle"
      searchApi="Postal/listarcalles"
      :searchFor="
        'calle=' +
          domicilioEditor.entreCalle2 +
          '&localidadId=' +
          domicilioEditor.localidadId
      "
      :setSelectedItem="setEntreCalle2Busqueda"
    ></app-lista-busqueda>
  </v-layout>
</template>

<script>
import Vue from 'vue';
import { http } from '@/axios';
import { mapGetters, mapMutations } from 'vuex';

export default {
  data: () => ({
    editModeOn: false,
    listaLocalidadesVisible: false,
    listaCallesVisible: false,
    listaEntreCalles1Visible: false,
    listaEntreCalles2Visible: false,
    loading: false,
    domicilio: {},
    domicilioEditor: { provinciaSeleccionada: {} },

    localidades: [],
    localidadValida: false,
    calleValida: false,
    esPrincipal: false,

    headersBusquedaLocalidades: [
      // definición de columnas
      { text: 'Localidad', value: 'nombre' },
      { text: 'Partido', value: 'partido' },
      { text: 'C.P.', value: 'codigoPostal' },
    ],
    headersBusquedaCalle: [
      // definición de columnas
      { text: 'Calle', value: 'nombre' },
      { text: 'Localidad', value: 'localidad' },
    ],
    selectedRow: [],
  }),
  props: {
    value: {
      type: Object,
      required: false,
    },
    provincias: {
      type: Array,
      required: false,
    },
    propName: {
      type: String,
      required: false,
      default: '',
    },
    label: {
      type: String,
      default: 'Domicilio',
    },
    iconName: {
      type: String,
      default: 'home',
    },
    editMode: {
      type: Boolean,
      default: true,
    },
    permitirEliminar: {
      type: Boolean,
      default: false,
    },
    setPredeterminado: Function,
  },
  watch: {
    value: function(item) {
      this.setDomicilio();
    },
  },
  computed: {
    ...mapGetters(['user', 'DebugModeOn']),
  },
  created() {
    // cargo las provincias
    //this.loadProvincias();

    // cargo el modelo
    this.setDomicilio();
  },
  methods: {
    ...mapMutations([
      'alertClear',
      'alertSuccess',
      'alertWarning',
      'alertError',
    ]),

    localidadesKeyUp(e) {
      if (e.keyCode === 13) {
        this.buscarLocalidad();
      }
    },
    calleKeyUp(e) {
      if (e.keyCode === 13) {
        this.buscarCalle();
      }
    },
    entreCalle1KeyUp(e) {
      if (e.keyCode === 13) {
        this.buscarEntreCalle1();
      }
    },
    entreCalle2KeyUp(e) {
      if (e.keyCode === 13) {
        this.buscarEntreCalle2();
      }
    },
    setDomicilio() {
      if (this.propName == '') {
        this.domicilio = this.value;
        this.copiarDomicilio(this.value, this.domicilioEditor); // hago una copia del domicilio para poder modificarlo si afeectar al original

        this.localidadValida = this.domicilioEditor.localidadId > 0;
        this.calleValida = this.domicilioEditor.calleId > 0;
        this.esPrincipal = this.domicilioEditor.esPrincipal;
      } else {
        if (!this.value[this.propName]) {
          // Si el domicilio no está cargado, creo la propiedad
          this.domicilio = {
            calle: '',
            localidad: '',
            codigoPostal: '',
            partido: '',
            provinciaId: '',
          };

          this.value[this.propName] = this.domicilio;
        }
        this.domicilio = this.value[this.propName];
      }
    },
    copiarDomicilio(source, destination) {
      destination.calle = source.calle;
      destination.calleId = source.calleId;
      destination.numero = source.numero;
      destination.piso = source.piso;
      destination.departamento = source.departamento;
      destination.entreCalle1 = source.entreCalle1;
      destination.entreCalle1Id = source.entreCalle1Id;
      destination.entreCalle2 = source.entreCalle2;
      destination.entreCalle2Id = source.entreCalle2Id;
      destination.barrio = source.barrio;
      destination.localidad = source.localidad;
      destination.localidadId = source.localidadId;
      destination.codigoPostal = source.codigoPostal;
      destination.partido = source.partido;

      destination.orden = source.orden;
      destination.esPrincipal = source.esPrincipal;

      if (destination.provinciaSeleccionada) {
        // estoy copiando al editor
        destination.provinciaSeleccionada = this.getProvinciaFromNombre(
          source.provincia
        );
      } else {
        // estoy copiando desde editor
        destination.provincia = source.provinciaSeleccionada.nombre;
      }
    },
    getProvinciaFromNombre(nombreProvincia) {
      if(!nombreProvincia || !this.provincias) {
        return {id: 0, nombre: nombreProvincia};
      }
      const provincia = this.provincias.find(
        (prov) => prov.nombre && prov.nombre.trim().toLowerCase() === nombreProvincia.trim().toLowerCase()
      );
      return provincia || {id: 0, nombre: nombreProvincia};
    },
    eliminar() {
      this.$parent.deleteChild(this.domicilio);
    },
    loadProvincias() {
      this.loading = true;
      try {
        var result = http.get('provincias'); // traigo todas
        this.provincias = result.list;

        if (this.domicilio.provincia == '') {
          this.domicilioEditor.provinciaSeleccionada = this.provincias[0];
        }
      } catch (error) {
        // Error
        Vue.$log.error(error);
      }
      this.loading = false;
    },
    setLocalidadBusqueda(localidad) {
      this.domicilioEditor.localidadId = localidad.id;
      this.domicilioEditor.localidad = localidad.nombre;
      this.domicilioEditor.codigoPostal = localidad.codigoPostal;
      this.domicilioEditor.partido = localidad.partido;

      this.localidadValida = this.domicilioEditor.localidadId > 0;
    },
    setCalleBusqueda(calle) {
      this.domicilioEditor.calle = calle.nombre;
      this.domicilioEditor.calleId = calle.id;
      this.domicilioEditor.localidad = calle.localidad;

      this.calleValida = this.domicilioEditor.calleId > 0;
    },
    setEntreCalle1Busqueda(calle) {
      this.domicilioEditor.entreCalle1 = calle.nombre;
      this.domicilioEditor.entreCalle1Id = calle.id;
    },
    setEntreCalle2Busqueda(calle) {
      this.domicilioEditor.entreCalle2 = calle.nombre;
      this.domicilioEditor.entreCalle2Id = calle.id;
    },
    editar() {
      this.copiarDomicilio(this.domicilio, this.domicilioEditor);
      this.editModeOn = true;
    },
    async marcarPredeterminado() {
      if (this.domicilio.esPrincipal) {
        this.alertWarning('Este domicilio ya es el Predeterminado.');
        return;
      }

      const res = await this.$dialog.confirm({
        text: '¿Confirma marcar como Predeterminado a este domicilio?',
        title: 'Confirmar Predeterminado',
        persistent: true, // Parece que no funciona...
      });
      if (!res) return;

      this.setPredeterminado(this.domicilio);

      this.domicilioEditor.esPrincipal = true;
      this.esPrincipal = this.domicilioEditor.esPrincipal;
    },
    async confirmarModificacion() {
      // valido
      if (
        this.domicilioEditor.calleId > 0 &&
        this.domicilioEditor.calleId == this.domicilioEditor.entreCalle1Id
      ) {
        this.alertWarning(
          'La Calle no puede ser la misma que la Entre Calle 1, por favor, verifique.'
        );
        return;
      }

      if (
        this.domicilioEditor.calleId > 0 &&
        this.domicilioEditor.calleId == this.domicilioEditor.entreCalle2Id
      ) {
        this.alertWarning(
          'La Calle no puede ser la misma que la Entre Calle 2, por favor, verifique.'
        );
        return;
      }

      if (
        this.domicilioEditor.entreCalle1Id > 0 &&
        this.domicilioEditor.entreCalle1Id == this.domicilioEditor.entreCalle2Id
      ) {
        this.alertWarning(
          'Las Entre Calles no puede ser iguales, por favor, verifique.'
        );
        return;
      }

      if (!this.localidadValida) {
        const res = await this.$dialog.confirm({
          text: 'La Localidad no ha sido validada ¿Confirma de todas formas?',
          title: 'Confirmar Domicilio',
          persistent: true, // Parece que no funciona...
        });
        if (!res) return;
      }

      this.copiarDomicilio(this.domicilioEditor, this.domicilio);
      this.editModeOn = false;
    },
    async changeLocalidad() {
      // reseteo la localidadId
      this.domicilioEditor.localidadId = 0;
      this.localidadValida = this.domicilioEditor.localidadId > 0;
    },
    async changeCalle() {
      // reseteo la calleId
      this.domicilioEditor.calleId = 0;
      this.calleValida = this.domicilioEditor.calleId > 0;
    },
    async buscarCalle() {
      if (
        this.domicilioEditor.calle == null ||
        this.domicilioEditor.calle.length < 3
      ) {
        this.alertWarning('Debe ingresar al menos 3 letras de la calle.');
        return;
      }

      if (this.domicilioEditor.localidadId == null) {
        this.alertWarning(
          'Por favor, ingrese la localidad antes de buscar la calle.'
        );
        return;
      }

      this.listaCallesVisible = true;
    },
    async buscarEntreCalle1() {
      if (
        this.domicilioEditor.entreCalle1 == null ||
        this.domicilioEditor.entreCalle1.length < 3
      ) {
        this.alertWarning('Debe ingresar al menos 3 letras de la calle.');
        return;
      }

      if (this.domicilioEditor.localidadId == null) {
        this.alertWarning(
          'Por favor, ingrese la localidad antes de buscar la calle.'
        );
        return;
      }

      this.listaEntreCalles1Visible = true;
    },
    async buscarEntreCalle2() {
      if (
        this.domicilioEditor.entreCalle2 == null ||
        this.domicilioEditor.entreCalle2.length < 3
      ) {
        this.alertWarning('Debe ingresar al menos 3 letras de la calle.');
        return;
      }

      if (this.domicilioEditor.localidadId == null) {
        this.alertWarning(
          'Por favor, ingrese la localidad antes de buscar la calle.'
        );
        return;
      }

      this.listaEntreCalles2Visible = true;
    },
    async buscarLocalidad() {
      if (!this.domicilioEditor.provinciaSeleccionada.id) {
        this.alertWarning(
          'Por favor, seleccione una provincia antes de consultar la Localidad.'
        );
        return;
      }

      if (
        this.domicilioEditor.localidad == null ||
        this.domicilioEditor.localidad.length < 4
      ) {
        this.alertWarning('Debe ingresar al menos 4 letras de la localidad.');
        return;
      }

      this.listaLocalidadesVisible = true;
    },
  },
};
</script>
